import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unify-marketing',
  templateUrl: './unify-marketing.component.html',
  styleUrls: ['./unify-marketing.component.css']
})
export class UnifyMarketingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/prospect/unify-marketing/unify-marketing.component.ts